import { useMemo } from 'react';
import { client } from './Client';
import { useFirestoreNoCompagnyGeneralOrderBy } from '../firebase/useFirestore';
import buildSyncedLinksMap from '../helpers/synchronisations/buildSyncedLinksMap';

/**
 * Map of locally-owned TOC elements (effects/activities/targetgroups) that are
 * paired to a parent portfolio: local element ID → portfolio CompagnyID.
 * Queries Synchronisations on the Project tenant field, the same rule-gated
 * pattern the subscribe modals use.
 * AI-CONTEXT: See docs/pitfalls.md#security-synchronisations-members-tenant-gate
 *
 * @returns {Record<string, string>}
 */
const useSyncedLinks = () => {
    const syncRows = useFirestoreNoCompagnyGeneralOrderBy(
        'Synchronisations',
        'Project',
        client,
        'Timestamp',
        'desc'
    );

    return useMemo(() => buildSyncedLinksMap(syncRows), [syncRows]);
};

export default useSyncedLinks;
